import React from 'react'
import PropTypes from 'prop-types'

const LandingOverview = ({ block }) => {
  const { title, overview, className } = block
  return (
    <div name='overview' className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 p-0 p-lg-5 align-self-center'>
        <div className='col-12 px-5 px-md-0 py-5 py-lg-4'>
          <p className='h5 mb-4 text-primary'>{!title ? 'Program Overview' : title}</p>
          <div className='program-overview' data-cy='program-overview'><div dangerouslySetInnerHTML={{ __html: overview }} /></div>
        </div>
      </div>
    </div>
  )
}

LandingOverview.propTypes = {
  block: PropTypes.object
}

export default LandingOverview
